import type { CSSProperties } from 'react';

const FRAME_WIDTH = 480;
const FRAME_HEIGHT = 847;
export const MUG_ASPECT_RATIO = FRAME_WIDTH / FRAME_HEIGHT;

export function getMugOverlayStyle(isMobileShell: boolean): CSSProperties {
  if (isMobileShell) {
    return {
      position: 'fixed',
      top: 0,
      right: 'calc(var(--shell-safe-right, 0px) + 8px)',
      height: '100vh',
      width: `calc(100vh * ${MUG_ASPECT_RATIO})`,
      pointerEvents: 'none',
    };
  }

  return {
    position: 'fixed',
    top: 0,
    height: '100vh',
    width: `calc(100vh * ${MUG_ASPECT_RATIO})`,
    right: 'calc(11rem - 40px)',
    pointerEvents: 'none',
  };
}
